(function () {



  //-- 产品内容 Tab
  //----------------------------------------------
  $('.tab-list .item').on('click', function () {
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');
  
    const activeIndex = $(this).index();

    const tabBody = $(this).parent('.tab-list').parent().parent().next();
    tabBody.find('.content')
           .eq(activeIndex).addClass('is-show')
           .siblings().removeClass('is-show');

  })


})();